import {Component, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {FeedbackService} from 'app/core/services/feedback.service';

@Component({
  selector: 'das-feedback-dialog',
  templateUrl: './feedback-dialog.component.html',
  styleUrls: ['./feedback-dialog.component.scss']
})
export class FeedbackDialogComponent {
  public summary: string = '';
  public description: string = '';

  @ViewChild('feedbackForm', {static: true}) public form: NgForm;

  constructor(private _feedbackService: FeedbackService, private _dialog: MatDialogRef<FeedbackDialogComponent>) {}

  /**
   * Sends feedback to the web-service.
   */
  public sendFeedback(): void {
    this._feedbackService
      .sendFeedback(this.summary, this.description)
      .then(this._closeDialog.bind(this))
      .catch(this._closeDialog.bind(this));
  }

  /**
   * Closes the dialog.
   */
  private _closeDialog(): void {
    this._dialog.close();
  }
}
